import { render, staticRenderFns } from "./CConstrunction.vue?vue&type=template&id=5fbbf988"
import script from "./CConstrunction.vue?vue&type=script&lang=js"
export * from "./CConstrunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fbbf988')) {
      api.createRecord('5fbbf988', component.options)
    } else {
      api.reload('5fbbf988', component.options)
    }
    module.hot.accept("./CConstrunction.vue?vue&type=template&id=5fbbf988", function () {
      api.rerender('5fbbf988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CConstrunction.vue"
export default component.exports